import { render, staticRenderFns } from "./View.vue?vue&type=template&id=2cf549b2"
import script from "./View.vue.ts?vue&type=script&lang=ts&external"
export * from "./View.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports